import Account from "@/helper/AccountHelper.js";
import ConfigManager from "@/config/ConfigManager.js";
import BzbsApi from '@/core/Http/BzbsApi.js';
import { map } from 'rxjs/operators';
export default {
    postTransferPoints: function(params) {
        const token = Account.getToken();
        const url = ConfigManager.getApiModuleUrl() + "/point/transfer";
        return BzbsApi.connectBzbsPost(url, token, params).pipe(map(res => res.data));
    },
}
